import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

/**
 * The backend completes the Google OAuth handshake server-side and 302-redirects
 * either to /dashboard (with httpOnly cookie set) or to /login?error=...
 *
 * If for some reason the browser lands here directly, we just refresh /me and
 * route accordingly so the user is never stuck.
 */
export default function GoogleCallback() {
  const { refresh } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();

  useEffect(() => {
    const error = params.get("error");
    if (error) {
      navigate(`/login?error=${error}`, { replace: true });
      return;
    }
    (async () => {
      const u = await refresh();
      navigate(u ? "/dashboard" : "/login", { replace: true });
    })();
  }, [refresh, navigate, params]);

  return (
    <div
      className="flex min-h-screen items-center justify-center bg-slate-50"
      data-testid="google-callback-loading"
    >
      <div className="flex items-center gap-3 text-sm text-slate-600">
        <div className="h-5 w-5 animate-spin rounded-full border-2 border-slate-200 border-t-indigo-600" />
        Completing sign-in…
      </div>
    </div>
  );
}
